<template>
  <div class="register_page">
    <!--Top Background-->
    <div class="top_background">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="title">
              <h4>{{ $t("cvsteps.title") }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Top Background-->
    <!--Cv Steps Page-->
    <div class="cv_steps_page">
      <div class="container">
        <div class="register_wizard_form">
          <div class="wizard_title">
            <h4>{{ $t("cvsteps.wizard_title") }}</h4>
            <p>{{ $t("cvsteps.wizard.desc") }}</p>
          </div>
          <!--Progress Bar-->
          <div class="progress_bar">
            <ul>
              <li :class="{ active: step == 1 }">
                <h4>01 {{ $t("cvsteps.wizard.chooseTemplate") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 2 }">
                <h4>02 {{ $t("cvsteps.wizard.pay") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 3 || step == 4 }">
                <h4>03 {{ $t("cvsteps.wizard.fillData") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
            </ul>
          </div>
          <!--Progress Bar-->

          <!--Cv Data-->
          <template v-if="step == 4">
            <template-one
              :item="cvData"
              v-if="tempLang == 'ar' || tempLang == 'both'"
            ></template-one>
            <button
              type="button"
              class="main_button button mt-3"
              @click="downloadPdf2()"
              v-if="tempLang == 'ar' || tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>
            <template-one-en
              :item="cvData"
              v-if="tempLang == 'en' || tempLang == 'both'"
            ></template-one-en>
            <button
              type="button"
              class="main_button button mt-3"
              @click="downloadPdf_en()"
              v-if="tempLang == 'en' || tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>
            <vue-html2pdf
              :show-layout="controlValue.showLayout"
              :float-layout="controlValue.floatLayout"
              :enable-download="controlValue.enableDownload"
              :preview-modal="controlValue.previewModal"
              :filename="controlValue.filename"
              :paginate-elements-by-height="
                controlValue.paginateElementsByHeight
              "
              :pdf-quality="controlValue.pdfQuality"
              :pdf-format="controlValue.pdfFormat"
              :pdf-orientation="controlValue.pdfOrientation"
              :pdf-content-width="controlValue.pdfContentWidth"
              :manual-pagination="controlValue.manualPagination"
              :html-to-pdf-options="htmlToPdfOptions"
              @progress="onProgress($event)"
              @startPagination="startPagination()"
              @hasPaginated="hasPaginated()"
              @beforeDownload="beforeDownload($event)"
              @hasDownloaded="hasDownloaded($event)"
              ref="html2Pdf"
            >
              <section slot="pdf-content">
                <template-one
                  :item="cvData"
                  v-if="tempLang == 'ar' || tempLang == 'both'"
                ></template-one>
                <!-- <div class="html2pdf__page-break" /> -->
                <!-- <template-one-en
                  :item="cvData"
                  v-if="tempLang == 'en' || tempLang == 'both'"
                ></template-one-en> -->
              </section>
            </vue-html2pdf>

            <vue-html2pdf
              :show-layout="controlValue.showLayout"
              :float-layout="controlValue.floatLayout"
              :enable-download="controlValue.enableDownload"
              :preview-modal="controlValue.previewModal"
              :filename="controlValue.filename"
              :paginate-elements-by-height="
                controlValue.paginateElementsByHeight
              "
              :pdf-quality="controlValue.pdfQuality"
              :pdf-format="controlValue.pdfFormat"
              :pdf-orientation="controlValue.pdfOrientation"
              :pdf-content-width="controlValue.pdfContentWidth"
              :manual-pagination="controlValue.manualPagination"
              :html-to-pdf-options="htmlToPdfOptions"
              @progress="onProgress($event)"
              @startPagination="startPagination()"
              @hasPaginated="hasPaginated()"
              @beforeDownload="beforeDownload($event)"
              @hasDownloaded="hasDownloaded($event)"
              ref="html2Pdf_en"
            >
              <section slot="pdf-content">
                <!-- <template-one
                  :item="cvData"
                  v-if="tempLang == 'ar' || tempLang == 'both'"
                ></template-one>
                <div class="html2pdf__page-break" /> -->
                <template-one-en
                  :item="cvData"
                  v-if="tempLang == 'en' || tempLang == 'both'"
                ></template-one-en>
              </section>
            </vue-html2pdf>

            <div class="actions_btns">
              <router-link
                :to="`/editCv/${tempLang}/${id}`"
                class="main_button button mt-3"
              >
                <span>{{ $t("edit") }}</span>
              </router-link>
            
            </div>






<div class="justify-content-center d-flex">

<div class="cvcolor color1" @click="change_color(1)"></div>
<div class="cvcolor color2" @click="change_color(2)"></div>
<div class="cvcolor color3 selected_color" @click="change_color(3)"></div>
<div class="cvcolor color4" @click="change_color(4)"></div>
<div class="cvcolor color5" @click="change_color(5)"></div>
<div class="cvcolor color6" @click="change_color(6)"></div>

</div>
            <div class="row">  
            <div class="col-md-3 col-sm-12"></div>          
            <div class="col-md-3 col-sm-6 mt-3">
             <input
                class="form-control"
                :placeholder="$t('newsleter.email')"
                v-model="email"
                style="border:1px solid #27bacf;border-radius: 35px;"
              />
            </div>

            <div class="col-md-2 col-sm-6 mt-3 ">
              <button class="btn main_button" @click="send_by_email" type="button">
                <span>{{ $t("send") }}</span>
              </button>
              </div>
             </div>


          </template>
          <!--Cv Data-->
        </div>
      </div>
    </div>
    <!--Cv Steps Page-->
  </div>
</template>

<script>
import TemplateOne from "../../../components/CvTemplate/TemplateOne.vue";
import TemplateOneEn from "../../../components/CvTemplate/TemplateOneEn.vue";
import html2canvas from "html2canvas";
import VueHtml2pdf from "vue-html2pdf";
import * as moment from "moment/moment";
export default {
  props: ["tempLang", "id"],
  components: {
    TemplateOne,
    TemplateOneEn,
    VueHtml2pdf,
  },
  data() {
    return {
      //Progress Step
      // step: 1,
      //Progress Step

      cvData: null,
      email: null,
      //Data
      allData: null,

      //loading
      loading: false,

      //   tempNum: null,
      //   tempPrice: null,
      //   tempLang: null,

      //Show Model
      show: false,

      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: false,
        previewModal: true,
        paginateElementsByHeight: 2999,
        manualPagination: true,
        filename: "Captin1 Report",
        pdfQuality: 2,
        pdfFormat: "a4",
        pdfOrientation: "portrait",
        pdfContentWidth: "800px",
      },
    };
  },
  methods: {
   //send_by_email
    send_by_email() {
      if (!this.email) {
        this.$iziToast.error({
          message: this.$t("newsleter.emailVal"),
        });
      } else {
        let submit_data = new FormData();
        submit_data.append("email", this.email);
        submit_data.append("tempLang", this.tempLang);
        submit_data.append("id", this.id);
        this.$axios({
          method: "post",
          url: "send_by_email",
          data: submit_data,
        })
          .then(() => {
            this.$iziToast.success({
              message: this.$t("newsleter.subSuccess"),
            });
            this.email = null;
          })
          .catch((err) => {
            this.$iziToast.error({
              message: err.response.data.error,
            });
          });
      }
    },
    //send_by_email
    async downloadPdf() {
      if (!(await this.validateControlValue())) return;
      this.$refs.html2Pdf.generatePdf();
    },
    downloadPdf2(){
      const url = window.location.href;
      const lastParam = url.split("/").slice(-1)[0];
      window.open("https://sas-jobs.net/cv/vendor/test.php?type=D&cv_id="+lastParam,"_self");


    },
    async downloadPdf_en() {
    const url = window.location.href;
    const lastParam = url.split("/").slice(-1)[0];
    window.open("https://sas-jobs.net/cv/vendor/test_eng.php?type=D&cv_id="+lastParam,"_self");

    },
    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 2;
        return false;
      }
      if (!this.controlValue.paginateElementsByHeight) {
        alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 11.7;
        return false;
      }
      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];
      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";
        return false;
      }
      if (!this.controlValue.pdfOrientation) {
        alert("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";
        return false;
      }
      if (!this.controlValue.pdfContentWidth) {
        alert("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";
        return false;
      }
      return true;
    },
    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`);
    },
    startPagination() {
      console.log(`PDF has started pagination`);
    },
    hasPaginated() {
      console.log(`PDF has been paginated`);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.log(`On Before PDF Generation`);
    },
    async toDataUrLImage(res) {
      return await this.toDataUrl(res);
    },
    hasDownloaded(blobPdf) {
      console.log(`PDF has downloaded yehey`);
      this.pdfDownloaded = true;
      console.log(blobPdf);
    },
    domRendered() {
      console.log("Dom Has Rendered");
      this.contentRendered = true;
    },
    onBlobGenerate(blob) {
      console.log(blob);
      console.log(blob);
    },

    //Cv Details
    getCv() {
      this.$axios({
        method: "GET",
        url: "cv_design_details?cv_id=" + this.id,
      }).then((res) => {
        this.cvData = res.data.data;
      });
    },

    //Country Code
    onSelect({ name, iso2, dialCode }) {
      console.log(name, iso2, dialCode);
      this.data.code = dialCode;
    },
    takeshot() {
      let div = document.getElementById("one_ar");

      // Use the html2canvas
      // function to take a screenshot
      // and append it
      // to the output div
      html2canvas(div).then(function (canvas) {
        document.getElementById("output").appendChild(canvas);
      });
    },
  },
  mounted() {
    this.getCv();
  },
  created() {
    this.$store.dispatch("cv_module/addStep", {
      step: 4,
    });
  },
  computed: {
    step() {
      return this.$store.getters["cv_module/cvStep"];
    },
    cv_id() {
      return this.$store.getters["cv_module/cvId"];
    },
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "cv.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      };
    },
  },
};
</script>

<style>
.skill_item {
  margin-bottom: 15px;
}

.skill_item span {
  font-size: 15px;
  display: flex;
  margin-bottom: 4px;
}

.range {
  width: 400px;
  height: 15px;
  -webkit-appearance: none;
  background: #cecece;
  direction: ltr;
  outline: none;
  border-radius: 0px;
  overflow: hidden;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 1); */
}
.range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #0eb6d8;
  cursor: pointer;
  border: 4px solid #fff;
  box-shadow: -407px 0 0 400px #0eb6d8;
}

.vue-country-select {
  margin-bottom: 15px;
  margin-inline-end: 5px;
}
.cvcolor{
width:50px;
height:50px;
border-radius: 50%;
margin:10px;
cursor: pointer;
}
.selected_color{
  border: solid;
}
.color1{
  background:#DFDFDF;
}
.color2{
  background:#0EB6D8;
}
.color3{
  background:#87CCAF;
}
.color4{
  background:#CEFFB1;
}
.color5{
  background:#E4A8F3;
}
.color6{
  background:#fac223;
}
</style>
